<template>
    <p
        v-if="(props.group && errorGroup.length) || errors.hasOwnProperty(errorKey)"
        class="inline-validation col-span-full text-sm font-semibold text-error mt-1"
    >
        <span
            v-if="props.group && errorGroup.length"
            class="space-y-2"
        >
            <span
                v-for="(error, index) in errorGroup"
                :key="index"
                v-html="error"
                class="block"
            ></span>
        </span>
        <span
            v-else-if="errors.hasOwnProperty(errorKey)"
            v-html="firstError"
        ></span>
    </p>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';

    const props = defineProps([
        'group',
        'errorKey',
        'errors',
    ]);


    const errorGroup = ref([]);

    const firstError = computed(() => {
        return Object.values(props.errors[props.errorKey])[0];
    });

    watch(() => props.errors, () => {
        if (props.group) {
            const keys = Object.keys(props.errors).filter((key) => {
                return key.startsWith(`${props.errorKey}.`);
            });

            const test = [];

            keys.forEach((key) => {
                Object.values(props.errors[key]).forEach((error) => {
                    test.push(error);
                });
            });

            errorGroup.value = test;
        }
    });
</script>
